<template>
  <div class="mt-2 mt-sm-3 position-relative">
    <b-row>
      <!-- Project Type -->
      <b-col cols="12" md="6">
        <b-form-group
          label="師傅編號："
          label-for="id"
          label-cols-md="3"
          class="align-items-center"
        >
          <div class="">
            {{
              workerData.user_number ? workerData.user_number : "系統自動生成"
            }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group
          label="狀態："
          label-for="worker_status"
          label-cols-md="3"
        >
          <b-form-checkbox
            :checked="workerData.is_active"
            name="is_active"
            switch
            inline
            v-model="workerData.is_active"
            value="1"
            style="margin-top: 5px"
          >
            {{ workerData.is_active ? "啟用" : "禁用" }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          label="工人註冊証號碼："
          label-for="registration_certificate_number"
          label-cols-md="3"
        >
          <b-form-input
            id="registration_certificate_number"
            v-model="workerData.registration_certificate_number"
            placeholder="輸入工人註冊証號碼"
            @blur="checkRegistrationCertificateNumber"
          />
          <label
            v-if="
              errorRegistrationCertificateNumberMessage &&
              workerData.registration_certificate_number
            "
            class="text-danger"
          >
            {{ errorRegistrationCertificateNumberMessage }}
          </label>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          label="建造業安全訓練證明書號碼："
          label-for="safety_training_certificate_number"
          label-cols-md="3"
        >
          <b-form-input
            id="safety_training_certificate_number"
            v-model="workerData.safety_training_certificate_number"
            placeholder="輸入建造業安全訓練證明書號碼"
            @blur="checkSafetyTrainingCertificateNumber"
          />
          <label
            v-if="
              errorSafetyTrainingCertificateNumberMessage &&
              workerData.safety_training_certificate_number
            "
            class="text-danger"
          >
            {{ errorSafetyTrainingCertificateNumberMessage }}
          </label>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_name_cn"
        >
          <b-form-group
            label="中文姓名："
            label-for="name_cn"
            label-cols-md="3"
            class="required"
          >
            <b-form-input
              id="name_cn"
              v-model="workerData.name_cn"
              placeholder="輸入中文姓名"
              :state="getValidationState(validationContext)"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_name"
        >
          <b-form-group
            label="系統帳號名稱："
            label-for="name"
            label-cols-md="3"
            class="required"
          >
            <b-form-input
              id="name"
              v-model="workerData.name"
              placeholder="輸入系統帳號名稱"
              :state="getValidationState(validationContext)"
              @blur="checkUserName"
            />
            <label
              v-if="errorNameMessage && workerData.name"
              class="text-danger"
            >
              {{ errorNameMessage }}
            </label>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <!-- gender -->
      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_gender_id"
        >
          <b-form-group
            label="性別"
            label-for="gender"
            label-cols-md="3"
            class="required"
          >
            <b-form-radio-group
              v-slot="{ ariaDescribedby }"
              style="margin-top: 10px"
              v-model="workerData.gender_id"
              name="gender"
            >
              <b-form-radio
                name="radio-options"
                :aria-describedby="ariaDescribedby"
                v-for="gender of genderOptions"
                :key="gender.name + gender.id"
                :value="gender.id"
                >{{ gender.name }}</b-form-radio
              >
            </b-form-radio-group>
            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <!-- id_number -->
      <b-col cols="12" md="6">
        <!-- <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_id_number"
        > -->
          <b-form-group
            label="身份證號碼："
            label-for="id_number"
            label-cols-md="3"
          >
          <!-- class="required" -->
            <!--
                <masked-input class="form-mark-input"
                    mask="*******\(*\)"
                    id="id_number"
                    v-model="workerData.id_number"

                    placeholder="輸入身份證號碼" /> -->

            <b-form-input
              id="id_number"
              v-model="workerData.id_number"
              @input="IsHKID(workerData.id_number)"
              placeholder="輸入身份證號碼"
            />
            <!--
              :state="getValidationState(validationContext)"
              <b-form-invalid-feedback :force-show="true">
              {{ idError ? idError : validationContext.errors[0] }}
            </b-form-invalid-feedback> -->
          </b-form-group>
        <!-- </validation-provider> -->
      </b-col>

      <!-- date_of_birth -->
      <b-col cols="12" md="6">
        <b-form-group
          label="出生日期："
          label-for="date_of_birth"
          label-cols-md="3"
        >
          <flat-pickr
            v-model="workerData.date_of_birth"
            class="form-control"
            :config="{
              allowInput: true,
              altInput: true,
              altFormat: 'Y-m-d',
              maxDate: 'today',
              dateFormat: 'Y-m-d',
              maxDate: maxDate,
            }"
            placeholder="輸入YYYY-MM-DD"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_phone"
        >
          <b-form-group
            label="聯絡電話："
            label-for="c_phone"
            label-cols-md="3"
            class="required"
          >
            <b-form-input
              id="c_phone"
              v-model="workerData.phone"
              placeholder="輸入聯絡電話"
              :state="getValidationState(validationContext)"
              @blur="handlePhoneChange"
            />
            <label
              v-if="errorPhoneMessage && workerData.phone"
              class="text-danger"
            >
              {{ errorPhoneMessage }}
            </label>
            <label
              v-if="workerData.phone && workerData.phone2"
              class="text-danger"
            >
              聯絡電話及備用電話號碼不能一樣
            </label>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="電郵" label-for="email" label-cols-md="3">
          <b-form-input
            id="email"
            v-model="workerData.email"
            placeholder="電郵"
            @blur="checkUserEmail"
          />
          <label
            v-if="errorEmailMessage && workerData.email"
            class="text-danger"
          >
            {{ errorEmailMessage }}
          </label>
        </b-form-group>
      </b-col>
      <!-- address -->
      <b-col cols="12" md="12">
        <div
          class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
        >
          <label>住宅地址：</label>
          <div class="input_wrap">
            <b-form-input
              id="c_address"
              v-model="workerData.address"
              placeholder="輸入住宅地址"
            />
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_payment_method_id"
        >
          <b-form-group
            label="計薪形式："
            label-for="payment_method_id"
            label-cols-md="3"
            class="required"
          >
            <v-select
              id="payment_method_id"
              v-model="workerData.payment_method_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="paymentMethodStatusOptions"
              :clearable="false"
              label="name"
              :reduce="(option) => option.id"
              placeholder="選擇計薪形式"
              :filter="paymentMethodSearch"
            >
            </v-select>

            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="銀行名稱：" label-for="bank_id" label-cols-md="3">
          <v-select
            id="bank_id"
            v-model="workerData.bank_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="bankOptions"
            :clearable="true"
            label="name"
            :reduce="(option) => option.id"
            placeholder="選擇銀行名稱"
            :filter="bankSearch"
          >
          </v-select>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <!-- <validation-provider
                  #default="validationContext"
                  name="戶口號碼"
                  rules="required"
                > -->
        <b-form-group
          label="戶口號碼："
          label-for="bank_account"
          label-cols-md="3"
        >
          <!-- :class="required" -->
          <b-form-input
            id="bank_account"
            v-model="workerData.bank_account"
            placeholder="輸入戶口號碼"
          />

          <!-- :state="getValidationState(validationContext)" -->
          <!-- <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
        </b-form-group>
        <!-- </validation-provider> -->
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="支付帳號名稱：" label-for="bank_id" label-cols-md="3">
          <b-form-input
              id="bank_account_name"
              v-model="workerData.bank_account_name"
              placeholder="輸入支付帳號名稱"
            />
        </b-form-group>
      </b-col>
      <!-- <b-col cols="12">
                <hr />
              </b-col>
              <b-col cols="12">
                <upload-file
                  key="fileupload1"
                  ref="childRef1"
                  custome_id="1"
                  title="⾝份証明⽂件"
                  :props_previewImage="props_previewImage"
                  v-on:file-uploaded="onFileUploaded"
                  file_delete_url="/user_documents"
                ></upload-file>
              </b-col> -->
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" md="6">
        <!-- <validation-provider
                  #default="validationContext"
                  name="職位"
                  rules="required"
                > -->
        <b-form-group
          label="職位："
          label-for="position"
          label-cols-md="3"
          :class="required"
        >
          <b-form-input
            id="position"
            v-model="workerData.position"
            placeholder="輸入職位"
          />
          <!-- :state="getValidationState(validationContext)"

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
        </b-form-group>
        <!-- </validation-provider> -->
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="部門：" label-for="department" label-cols-md="3">
          <b-form-input
            id="department"
            v-model="workerData.department"
            placeholder="輸入部門"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="此欄"
          rules="required"
          vid="v_join_date"
        >
          <b-form-group
            label="加入日期："
            label-for="join_date"
            label-cols-md="3"
            class="required"
          >
            <flat-pickr
              v-model="workerData.join_date"
              class="form-control"
              :config="{
                allowInput: true,
                altInput: true,
                altFormat: 'Y-m-d',
                dateFormat: 'Y-m-d',
              }"
              placeholder="輸入YYYY-MM-DD"
            />
            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row class="mt-1" v-if="workerData.id == 0">
      <!-- Field: Password -->
      <b-col cols="12" md="6">
        <validation-provider
          #default="validationContext"
          name="密碼"
          rules="required|min:8"
          vid="v_password"
        >
          <b-form-group
            class="required"
            label="密碼"
            label-for="password"
            label-cols-md="3"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="password"
                :type="passwordFieldType"
                :state="getValidationState(validationContext)"
                v-model="workerData.password"
                name="password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <!-- Field: Password Confirm -->
      <b-col cols="12" md="6" v-if="workerData.id == 0">
        <validation-provider
          #default="validationContext"
          name="確認密碼"
          rules="required|min:8|confirmed:v_password"
        >
          <b-form-group
            class="required"
            label="確認密碼"
            label-for="password_confirmation"
            label-cols-md="3"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="password_confirmation"
                :type="passwordConfirmFieldType"
                :state="getValidationState(validationContext)"
                v-model="workerData.password_confirmation"
                name="password_confirmation"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordConfirmToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  data() {
    return {
      required,
      idError: null,
      dragAndDropCapable: false,
      errorRegistrationCertificateNumberMessage: null,
      errorSafetyTrainingCertificateNumberMessage: null,
      errorNameCnMessage: null,
      errorNameMessage: null,
      errorPhoneMessage: null,
      errorEmailMessage: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  methods: {
    changePassword() {
      this.workerData.password =
        "WF_" + this.workerData.phone.toString().slice(-4) + "_dc";
      this.workerData.password_confirmation =
        "WF_" + this.workerData.phone.toString().slice(-4) + "_dc";
    },
    onFileUploaded(file) {
      this.workerData.documents = file;
    },
    bankSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    paymentMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    handlePhoneChange() {
      this.changePassword();
      this.checkUserPhone();
    },
    checkRegistrationCertificateNumber() {
      store
        .dispatch("worker/checkRegistrationCertificateNumber", {
          id: this.workerData.id ? this.workerData.id : null,
          registration_certificate_number:
            this.workerData.registration_certificate_number,
        })
        .then((response) => {
          this.errorRegistrationCertificateNumberMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorRegistrationCertificateNumberMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    checkSafetyTrainingCertificateNumber() {
      store
        .dispatch("worker/checkSafetyTrainingCertificateNumber", {
          id: this.workerData.id ? this.workerData.id : null,
          safety_training_certificate_number:
            this.workerData.safety_training_certificate_number,
        })
        .then((response) => {
          this.errorSafetyTrainingCertificateNumberMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorSafetyTrainingCertificateNumberMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    checkUserNameCn() {
      store
        .dispatch("app/checkUserNameCn", {
          id: this.workerData.id ? this.workerData.id : null,
          name_cn: this.workerData.name_cn,
        })
        .then((response) => {
          this.errorNameCnMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameCnMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    checkUserName() {
      store
        .dispatch("app/checkUserName", {
          id: this.workerData.id ? this.workerData.id : null,
          name: this.workerData.name,
        })
        .then((response) => {
          this.errorNameMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    checkUserPhone() {
      store
        .dispatch("app/checkUserPhone", {
          id: this.workerData.id ? this.workerData.id : null,
          phone: this.workerData.phone,
        })
        .then((response) => {
          this.errorPhoneMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorPhoneMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    checkUserEmail() {
      store
        .dispatch("app/checkUserEmail", {
          id: this.workerData.id ? this.workerData.id : null,
          email: this.workerData.email,
        })
        .then((response) => {
          this.errorEmailMessage = null;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorEmailMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : null;
          }
        });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    IsHKID(str) {
      return true;
      var strValidChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      // basic check length
      if (str.length < 8) {
        this.idError = "身份證號碼" + str + "不正確";
        return false;
      }

      // handling bracket
      if (
        str.charAt(str.length - 3) == "(" &&
        str.charAt(str.length - 1) == ")"
      )
        str = str.substring(0, str.length - 3) + str.charAt(str.length - 2);

      // convert to upper case
      str = str.toUpperCase();

      // regular expression to check pattern and split
      var hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;

      var matchArray = str.match(hkidPat);

      // not match, return false
      if (matchArray == null) {
        this.idError = "身份證號碼" + str + "不正確";
        return;
      }

      // the character part, numeric part and check digit part
      var charPart = matchArray[1];
      var numPart = matchArray[2];
      var checkDigit = matchArray[3];

      // calculate the checksum for character part
      var checkSum = 0;
      if (charPart.length == 2) {
        checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
        checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
      } else {
        checkSum += 9 * 36;
        checkSum += 8 * (10 + strValidChars.indexOf(charPart));
      }

      // calculate the checksum for numeric part
      for (var i = 0, j = 7; i < numPart.length; i++, j--)
        checkSum += j * numPart.charAt(i);

      // verify the check digit
      var remaining = checkSum % 11;
      var verify = remaining == 0 ? 0 : 11 - remaining;

      if (verify == checkDigit || (verify == 10 && checkDigit == "A")) {
        this.idError = null;
      } else {
        this.idError = "身份證號碼" + str + "不正確";
      }
    },
  },
  props: {
    workerData: {
      type: Object,
      required: true,
    },
    genderOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const props_previewImage = ref([]);
    watch(
      () => props.workerData,
      (newVal) => {
        if (newVal.documents) {
          props_previewImage.value = [...newVal.documents];
        }
      }
    );
    const resetWorkData = () => {
      workerData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    const passwordFieldType = ref("password");
    const passwordConfirmFieldType = ref("password");

    const togglePasswordVisibility = () => {
      passwordFieldType.value =
        passwordFieldType.value === "password" ? "text" : "password";
      passwordConfirmFieldType.value =
        passwordConfirmFieldType.value === "password" ? "text" : "password";
    };

    const passwordToggleIcon = computed(() =>
      passwordFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );
    const passwordConfirmToggleIcon = computed(() =>
      passwordConfirmFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      props_previewImage,
      passwordFieldType,
      passwordConfirmFieldType,
      togglePasswordVisibility,
      passwordToggleIcon,
      passwordConfirmToggleIcon,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
